import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    sessionID: '123',
    // 需要显示的值
    loginRouterinfo: {},
    // 需要提交的值
    loginRouterinfos: {},
    shiftReservation: {} || [],
    password: '',
    lnglat: {},
    routerLists: {},
    statusVal: 0,
    yearAndMonth: ''

  },
  // 所有mutations中的方法的第一个参数一定是state变量，用来进行对state中的状态的操作
  // 第二个参数是可选参数，用于调用该 mutations 方法的时候传参
  // getSession (state) {
  //   return state.sessionID
  // },
  mutations: {
    'SET_LOGININFO': (state, routerInfo) => {
      state.loginRouterinfo = routerInfo
    },
    'SET_LOGININFOS': (state, routerInfo) => {
      state.loginRouterinfos = routerInfo
    },
    'SET_SHITINFO': (state, obj) => {
      state.shiftReservation = obj
    },
    'SET_PASSWORD': (state, val) => {
      state.password = val
    },
    'SET_LNGLAT': (state, val) => {
      state.lnglat = val
    },
    'SET_ROUTERLIST': (state, val) => {
      state.routerLists = val
    },
    'SET_STATUS': (state, val) => {
      state.statusVal = val
    },
    'SET_YEARANDMONTH': (state, val) => {
      state.yearAndMonth = val
    },
    setSession (state, sessionID) {
      state.sessionID = sessionID
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js